// Copyright 2017 Sorama B.V.

/**
 * NOTE: This class is not used yet, however it does work in chrome, opera and probably firefox and might be useful in the future
 */
export class WorkerPromise<T> {
    private workerBlob: Blob;
    private worker: Worker;
    private workerPromise: Promise<T>;

    constructor(workerCode: (parameters: unknown[]) => void, parameters: unknown[]) {
        // Convert code to string
        const codeBodyMatches = workerCode.toString().match(/^\s*function\s*\([\s\w]*\)\s*\{(([\s\S](?!\}$))*[\s\S])/);
        if (!codeBodyMatches || codeBodyMatches.length < 2) throw new Error("Invalid function");

        // Create worker body code
        const workerBody =
            " \
        onmessage = function (msg){ \
                const parameters = msg.data; " +
            codeBodyMatches[1] +
            "postMessage(result); }";

        this.workerBlob = new Blob([workerBody], { type: "text/javascript" });
        this.worker = new Worker(window.URL.createObjectURL(this.workerBlob));

        this.workerPromise = new Promise<T>((resolve, reject) => {
            this.worker.onmessage = (msg: MessageEvent) => {
                resolve(<T>msg.data);
                this.worker.terminate();
            };

            this.worker.onerror = (msg: ErrorEvent) => {
                reject(msg.message);
                this.worker.terminate();
            };
        });

        this.worker.postMessage(parameters);
    }

    public toPromise(): Promise<T> {
        return this.workerPromise;
    }
}
